// assets/ovolin-mega-menu.js
document.addEventListener('DOMContentLoaded', function () {
  const DESKTOP_QUERY = window.matchMedia('(min-width: 1024px)');
  const HOVER_CAPABLE = window.matchMedia('(hover: hover) and (pointer: fine)');

  // --- Dynamic height so menu never runs off-screen ---
  (function () {
    const wrapper = document.querySelector('.ovolin-mega-menu-wrapper');
    if (!wrapper) return;

    function updateMegaMaxHeight() {
      if (!DESKTOP_QUERY.matches) return;
      const rect = wrapper.getBoundingClientRect();
      const gap = 16;
      const available = Math.max(320, Math.floor(window.innerHeight - rect.bottom - gap));
      document.documentElement.style.setProperty('--mega-max-h', available + 'px');
    }

    window.addEventListener('load', updateMegaMaxHeight);
    window.addEventListener('resize', updateMegaMaxHeight);
    document.querySelectorAll('.ovolin-mega-menu > li.has-dropdown').forEach(li => {
      li.addEventListener('mouseenter', updateMegaMaxHeight);
      li.addEventListener('focusin', updateMegaMaxHeight);
    });
  })();

  // --- Top-level dropdown behavior ---
  const topDropdownLis = document.querySelectorAll('.ovolin-mega-menu > li.has-dropdown');

  topDropdownLis.forEach(li => {
    const trigger = li.querySelector(':scope > a');
    if (!trigger) return;

    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-expanded', 'false');

    function setExpanded(state) {
      trigger.setAttribute('aria-expanded', state ? 'true' : 'false');
      li.classList.toggle('open', !!state);
    }

    li.addEventListener('mouseenter', () => {
      if (DESKTOP_QUERY.matches && HOVER_CAPABLE.matches) setExpanded(true);
    });
    li.addEventListener('mouseleave', () => {
      if (DESKTOP_QUERY.matches && HOVER_CAPABLE.matches) setExpanded(false);
    });

    li.addEventListener('focusin', () => {
      if (DESKTOP_QUERY.matches) setExpanded(true);
    });
    li.addEventListener('focusout', (e) => {
      if (DESKTOP_QUERY.matches && !li.contains(e.relatedTarget)) setExpanded(false);
    });

    trigger.addEventListener('click', (e) => {
      if (!(DESKTOP_QUERY.matches && !HOVER_CAPABLE.matches)) return;
      if (e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      const isOpen = li.classList.contains('open');
      topDropdownLis.forEach(x => {
        if (x !== li) {
          x.classList.remove('open');
          const a = x.querySelector(':scope > a');
          if (a) a.setAttribute('aria-expanded', 'false');
        }
      });
      setExpanded(!isOpen);
    });

    trigger.addEventListener('keydown', (e) => {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        setExpanded(true);
      } else if (e.key === 'Escape') {
        setExpanded(false);
        trigger.focus();
      }
    });
  });

  // --- Tabs ---
  const tabItems  = document.querySelectorAll('.mega-menu-tab-item[data-tab]');
  const tabPanels = document.querySelectorAll('.tab-panel');

  function activateTab(tabName, clickedEl) {
    tabItems.forEach(t => {
      const isActive = t === clickedEl;
      t.classList.toggle('active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (isActive) t.setAttribute('tabindex', '0');
    });
    tabPanels.forEach(p => {
      const match = p.getAttribute('data-panel') === tabName;
      p.classList.toggle('active', match);
      p.setAttribute('aria-hidden', match ? 'false' : 'true');
    });
  }

  function clearTabs() {
    tabItems.forEach(t => {
      t.classList.remove('active');
      t.setAttribute('aria-selected', 'false');
    });
    tabPanels.forEach(p => {
      p.classList.remove('active');
      p.setAttribute('aria-hidden', 'true');
    });
  }

  tabItems.forEach(item => {
    const tabName = item.getAttribute('data-tab');
    if (!tabName) return;

    item.addEventListener('click', (e) => {
      e.preventDefault();
      activateTab(tabName, item);
    });

    item.addEventListener('keydown', (e) => {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        activateTab(tabName, item);
      } else if (e.key === 'Escape') {
        clearTabs();
        item.blur();
      }
    });

    item.addEventListener('mouseenter', () => {
      if (DESKTOP_QUERY.matches && HOVER_CAPABLE.matches) {
        activateTab(tabName, item);
      }
    });
  });

  const megaLi = document.querySelector('.ovolin-mega-menu > li.is-mega');
  if (megaLi) {
    megaLi.addEventListener('mouseleave', () => {
      if (DESKTOP_QUERY.matches && HOVER_CAPABLE.matches) {
        clearTabs();
      }
    });
  }
});
